class Select {
    static openDropdown = null;

    constructor(toggleId, menuId, iconId, options, defaultValue = '', onSelect,optionClassName) {

        this.dropdownToggle = document.getElementById(toggleId);
        this.dropdownMenu = document.getElementById(menuId);
        this.dropdownIcon = document.getElementById(iconId);
        this.options = options; // 直接使用对象数组
        this.onSelect = onSelect;
        this.selectedValue = defaultValue;
        this.optionClassName = optionClassName;
        this.init(defaultValue);
    }

    init(defaultValue) {
        this.createDropdownItems();

        if (defaultValue) {
            this.setSelectedValue(defaultValue);
        }

        this.dropdownToggle.addEventListener('click', (event) => {
            event.preventDefault();
            if (Select.openDropdown && Select.openDropdown !== this) {
                Select.openDropdown.closeDropdown();
            }
            const isOpen = this.dropdownMenu.classList.toggle('show');
            this.dropdownMenu.style.display = isOpen ? 'flex' : 'none';
            this.dropdownIcon.classList.toggle('up', isOpen);
            Select.openDropdown = isOpen ? this : null;

            requestAnimationFrame(() => {
                if (this.selectedValue) {
                    const selectedItem = Array.from(this.dropdownMenu.children).find(item => item.dataset.value === this.selectedValue);
                    if (selectedItem) {
                        this.dropdownMenu.scrollTop = selectedItem.offsetTop;
                    }
                } else {
                    this.dropdownMenu.scrollTop = 0;
                }
            });

            event.stopPropagation();
        });

        document.addEventListener('click', () => {
            this.closeDropdown();
        });
    }

    createDropdownItems() {
        this.options.forEach(option => {
            const item = document.createElement('div');
            if (this.optionClassName){
                item.className = 'rs-select-item swiper-move-prevent ' + this.optionClassName;
            } else {
                item.className = 'rs-select-item swiper-move-prevent';
            }
            item.textContent = option.label; // 显示 label
            item.dataset.value = option.value; // 存储 value

            if (option.value === this.selectedValue) {
                if (this.optionClassName){
                    item.classList.add(this.optionClassName + '-selected');
                }
                item.classList.add('rs-select-selected');
            }

            item.addEventListener('click', () => {
                this.setSelectedValue(option.value);
                this.closeDropdown();
            });
            this.dropdownMenu.appendChild(item);
        });
    }

    setSelectedValue(value) {
        this.selectedValue = value;
        const selectedOption = this.options.find(option => option.value === value);
        this.dropdownToggle.querySelector('span').textContent = selectedOption ? selectedOption.label : ''; // 设置选中的 label

        Array.from(this.dropdownMenu.children).forEach(item => {
            item.classList.toggle('rs-select-selected', item.dataset.value === value);
            if (this.optionClassName){
                item.classList.toggle(this.optionClassName + '-selected', item.dataset.value === value);
            }
        });

        // 调用回调函数
        if (this.onSelect) {
            this.onSelect(selectedOption); // 选中时触发回调
        }
    }

    closeDropdown() {
        this.dropdownMenu.classList.remove('show');
        this.dropdownIcon.classList.remove('up');
        this.dropdownMenu.style.display = 'none';
        if (Select.openDropdown === this) {
            Select.openDropdown = null;
        }
    }
}